import React, { Component } from 'react';
import { Form, Button, Checkbox, message } from 'antd';
import axios from 'axios';

import './style.css';

function trackFreeToolEvent(eventName, errorLabel) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: eventName,
		eventCategory: 'www_free_tools',
		eventAction: 'local_rankflux',
		eventLabel: errorLabel || null,
		eventDescription: null,
	});
}

class EmailForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			subscribed: false,
			error: null,
		};
	}

	handleSubmit = async (values) => {
		if (values.bl_botField) {
			console.warn('Spam detected');
			message.error('Spam detected. Submission rejected.');
			trackFreeToolEvent('tool_error', 'Spam detected');
			return;
		}

		trackFreeToolEvent('details_submitted');

		try {
			this.setState({ loading: true, error: null });

			// All HubSpot calls happen server-side in hubspot-subscribe.php
			const subscribeUrl = window.rankfluxConfig?.subscribeUrl || `${window.location.origin}/wp-json/rankflux/v1/subscribe`;

			const { data } = await axios.post(subscribeUrl, {
				email: values.bl_email,
				firstname: values.bl_firstname,
				frequency: values.bl_frequency || [],
				bl_botField: values.bl_botField || '',
			});

			if (data.existing) {
				message.warning("You were already subscribed. Your preferences have been updated.");
			} else {
				message.success("Subscription successful!");
			}

			this.setState({ loading: false, subscribed: true });
			trackFreeToolEvent('details_submitted_successfully');

		} catch (error) {
			console.error("Error occurred during subscription process:", error.response?.data || error.message);
			const errorMessage = error.response?.data?.message || 'Subscription failed. Please try again.';
			this.setState({ loading: false, error: errorMessage });
			message.error(errorMessage);
			trackFreeToolEvent('tool_error', errorMessage);
		}
	};



	render() {
		const { loading, subscribed, error } = this.state;

		return (
			<div className="rf-email-form">
				<div class="heading">
					<h5>
						Be the first to hear about local algorithm volatility. Subscribe to <span className="bold">Local RankFlux email alerts</span>{' '}
						today!
					</h5>

					{error && <div className="rf-error-message">{error}</div>}
				</div>

				<Form onFinish={this.handleSubmit}>
					<div className="rf-email-wrapper">
						<Form.Item
							name="bl_email"
							rules={[
								{
									required: true,
									message: 'Please enter your email address',
								},
							]}
						>
							<input
								className="rf-email-input"
								type="email"
								placeholder="Email address"
							/>
						</Form.Item>
						<Form.Item
							name="bl_firstname"
							rules={[
								{
									required: true,
									message: 'Please enter your first name',
								},
							]}
						>
							<input
								className="rf-email-input"
								type="text"
								placeholder="First name"
							/>
						</Form.Item>

						<Form.Item
							name="bl_frequency"
							initialValue={[]}
							className="rf-select-frequency"
							label="Email frequency"
							rules={[
								{
									required: true,
									message: 'Please select an Email frequency',
								},
							]}
						>
							<Checkbox.Group className="rf-email-checkbox">
								<Checkbox value="Weekly">Weekly</Checkbox>
								<Checkbox value="Daily">Daily</Checkbox>
								<Checkbox value="Urgent">Urgent</Checkbox>
							</Checkbox.Group>
						</Form.Item>

						<Form.Item name="bl_botField" style={{ display: 'none' }}>
							<input type="text" placeholder="Leave this empty" />
						</Form.Item>
					</div>

					<Form.Item className="rf-email-button">
						<Button
							className="button rf-subscribe-btn blue"
							type="primary"
							htmlType="submit"
							disabled={loading || subscribed}
						>
							{loading ? 'Subscribing...' : subscribed ? 'Subscribed' : 'Subscribe'}
						</Button>
					</Form.Item>
				</Form>
			</div>
		);
	}
}

export default EmailForm;
